const HTML_TAG_PATTERN = /<[a-z][\s\S]*>/i

export function isHtmlContent(value) {
  return HTML_TAG_PATTERN.test(value || '')
}

export const RICH_DESCRIPTION_ALLOWED_TAGS = ['p', 'br', 'strong', 'em', 'h2', 'h3', 'ul', 'ol', 'li', 'a', 'img']

export const EVENT_DESCRIPTION_ALLOWED_TAGS = ['p', 'br', 'strong', 'em', 'h2', 'h3', 'ul', 'ol', 'li', 'a']

export const EVENT_DESCRIPTION_ALLOWED_ATTR = ['href']

export const RICH_DESCRIPTION_ALLOWED_ATTR = ['href', 'src', 'alt']
